<main
  class="warranty-and-refunds-component"
  [class.desktop]="!(lessThan$ | async)?.sm"
  [class.single-header]="!(lessThan$ | async)?.mobileXL"
  *transloco="let t">
  <div class="wrapper scroll" id="mainAppScroll">
    <div class="content">
      <article class="content-wrapper">
        <section class="flex flex-col">
          @if (lang !== 'AR') {
            <h1>Return & Refund Policy</h1>
            <span class="bold">Every order is 100% Risk-Free. </span>
            <span
              >Here's what you need to know about taking advantage of Popsy's 14-day
              return policy.
            </span>
          } @else {
            <h1>سياسة الإرجاع والاسترداد</h1>
            <strong
              >حول تجربة التسوق عبر الإنترنت إلى الدفع على أقساط شهرية من دون فكل طلب خالٍ
              من المخاطر بنسبة 100٪.
            </strong>
            <span
              >إليك ما تحتاج لمعرفته حول الاستفادة من سياسة الإرجاع مع Popsy لمدة 14
              يومًا.
            </span>
          }

          <span class="fixed-space-32" aria-hidden="true"></span>

          <div class="faq">
            @for (item of refundFaqData; track item; let i = $index) {
              <div class="item">
                <div class="question" (click)="item.open = !item.open">
                  @if (lang !== 'AR') {
                    <span>{{ item.question }}</span>
                  }
                  @if (lang === 'AR') {
                    <span>{{ item.questionAr }}</span>
                  }
                  <span class="fixed-space-8" aria-hidden="true"></span>
                  <popsy-icon-chevron-down
                    class="icon icon fill-gray-01"
                    [class.selected]="item.open" />
                </div>
                @if (lang !== 'AR') {
                  <div
                    class="answer"
                    [class.selected]="item.open"
                    [innerHTML]="item.answer"></div>
                }
                @if (lang === 'AR') {
                  <div
                    class="answer"
                    [class.selected]="item.open"
                    [innerHTML]="item.answerAr"></div>
                }
                @if (i === 1 && item.open) {}
                <span class="line fill-row"></span>
              </div>
            }
          </div>

          <span class="fixed-space-64" aria-hidden="true"></span>

          <div class="popsy-card gray">
            @if (lang !== 'AR') {
              <h2>Need to return your device?</h2>
            } @else {
              <h2>هل تود بإعادة الجهاز الخاص بك؟</h2>
            }
            <span class="fixed-space-16" aria-hidden="true"></span>

            <a [routerLink]="getRefungUrlFragment()" class="flex flex-col">
              <button class="popsy-button-primary">
                @if (lang !== 'AR') {
                  Submit a Return Request
                } @else {
                  تقديم طلب إرجاع
                }
              </button>
            </a>
            <span class="fixed-space-16" aria-hidden="true"></span>
          </div>

          <span class="fixed-space-64" aria-hidden="true"></span>

          @if (lang !== 'AR') {
            <h1>Free Warranty Policy</h1>

            <span
              >Popsy is confident that the devices we offer for sale are in perfect
              working condition, that is why every device comes with a free 12-month free
              warranty. In case of any defects during the free warranty period, we will
              make sure your device is either repaired or replaced, for free.
            </span>
          } @else {
            <h1>سياسة الضمان المجاني</h1>

            <span
              >بوبسي واثقة من أن الأجهزة التي نقدمها للبيع في حالة عمل مثالية، ولهذا السبب
              يأتي كل جهاز مع ضمان مجاني لمدة 12 شهرًا. في حالة حدوث أي عيوب خلال فترة
              الضمان المجاني، سنتأكد من إصلاح جهازك أو استبداله مجانًا.
            </span>
          }

          <div class="faq">
            @for (item of warrantyFaqData; track item; let i = $index) {
              <div class="item">
                <div class="question" (click)="item.open = !item.open">
                  @if (lang !== 'AR') {
                    <span>{{ item.question }}</span>
                  }
                  @if (lang === 'AR') {
                    <span>{{ item.questionAr }}</span>
                  }
                  <span class="fixed-space-8" aria-hidden="true"></span>
                  <popsy-icon-chevron-down
                    class="icon fill-gray-01"
                    [class.selected]="item.open" />
                </div>
                @if (lang !== 'AR') {
                  <div
                    class="answer"
                    [class.selected]="item.open"
                    [innerHTML]="item.answer"></div>
                }
                @if (lang === 'AR') {
                  <div
                    class="answer"
                    [class.selected]="item.open"
                    [innerHTML]="item.answerAr"></div>
                }
                @if (i === 1 && item.open) {}
                <span class="line fill-row"></span>
              </div>
            }
          </div>
        </section>
        <app-other-topics></app-other-topics>
      </article>
      @if ((lessThan$ | async)?.mobileL !== true) {
        <span class="fixed-space-64" aria-hidden="true"></span>
      }
      @if (!(inFullScreenMode$ | async)) {
        <app-footer
          class="footer"
          [class.phone]="(lessThan$ | async)?.mobileL"></app-footer>
      }
    </div>
  </div>
</main>
